<template>
	<div id="app">
		<Loading :hideInside="true" :state="loading">
      <div id="header">
        <a href="/" class="title">{{ $root.pageTitle }}</a>
        <div class="langInterf" :data-content="$t( 'LangInterf' )">
          <select
            v-model="langInterf"
          >
            <option :value="l" v-for="l in $options.languages" :key="l">{{ languageName( l ) }}</option>
          </select>
        </div>
        <div class="langData" :data-content="$t( 'LangData' )">
          <select
            v-model="langData"
          >
            <option value="" key=""></option>
            <option :value="l" v-for="l in $options.languages" :key="l">{{ languageName( l ) }}</option>
          </select>
        </div>
        <div class="dateData" :data-content="$t( 'dateData' )" :class="dateData ? 'choiced' : ''">
          <Datetime
            class="dateDataInput"

            ref="dateDataInput"

            :timeUse="true"
            :secondsUse="true"

            v-model="dateData_"

            @blur="dateDataSet( 'blur' )"
            @ok="dateDataSet( 'ok' )"
            @calendar="dateDataSet( 'calendar' )"
          />
          <Icon
            symbol="clear"
            class="clear"
            @click.native="dateDataSet( 'clear' )"
          />
<!--
          <Datetime
            class="dateDataInput"

            ref="dateDataInput"

            :timeUse="true"
            :secondsUse="true"

            v-model="dateData_"

            @blur="dateDataSet( 'blur' )"
            @ok="dateDataSet( 'ok' )"
            @calendar="dateDataSet( 'calendar' )"
          />
          <Icon
            symbol="clear"
            class="clear"
            @click.native="dateDataSet( 'clear' )"
          />
          <Tooltip
            :show="!!dateDataErr"

            orientation="bottom"
            type="error"
            class="errorTip"
            @close="dateDataErr=null"
            style="width: 12em;"
          >
            <span v-html="dateDataErr"></span>
          </Tooltip>
-->
        </div>
        <a href="/logout" class="user">
          <Icon
            symbol="logout"
            class="logoutIcon"
          />
          {{ userName }}
        </a>
        <a
          v-if="permitted( 'preferences' )"

          href="/prefs"
          target="_blank"
          class="prefs"
        >
          <Icon
            symbol="prefs"
          />
        </a>
      </div>
			<router-view v-if="render" />
		</Loading>
		<Notify
      :delayWarnings="30000"
      :delayErrors="30000"
    />
	</div>
</template>

<script>
	import Loading from "@/components/Loading";
	import Notify from "@/components/Notify";
	import Icon from "@/components/Icon";
  import Tooltip from "@/components/Tooltip";
  import Datetime from "@/components/Datetime";

  import utils from "@/utils";
  import dates from "@/dates";
  import ls from "@/ls";

	export default {
		name: "App",
		components: {
      Tooltip,
      Datetime,
			Loading,
			Notify,
      Icon
		},

    utils,

    i18n: {
      messages: {
        ru: {
          LangInterf: "Язык",
          LangData: "Язык данных",
          dateData: "Дата данных",
          DateInvalid: "Дата и время должна быть в формате «дд.мм.гг чч:мм:сс»"
        },

        en: {
          LangInterf: "Language",
          LangData: "Data language",
          dateData: "Data date",
          DateInvalid: "Date and time must be in format «yyyy-mm-dd hh:mm:ss»"
        },

        kz: {
          LangInterf: "Тіл",
          LangData: "Деректер тілі",
          dateData: "Деректер күні",
          DateInvalid: "Дата и время должна быть в формате «дд.мм.гг чч:мм:сс»",
        }
      }
    },

    data() {
			return {
				loading: false,
        dateDataInitial: false,
        dateDataErr: null,

        dateData_: null,

        render: true
			}
		},

    created() {
      this.$root.pageTitle = "DataVera EKG Explorer";

      this.$root.$on(
        "render",
        () => {
          this.render = false;
          this.$nextTick( () => { this.render = true; } );
        }
      );
    },

    methods: {
		  languageName( k ) {
		    const kt = this.$options.utils.capitalize( k );
		    return this.$t( kt, k );
      },

      dateDataSet( event ) {
        let v = null;

        if ( event == "clear" ) v = "";
        else {
          let parsed;
          try {
            parsed = dates.parse( this.dateData_, dates.types.RUS4Y );
          }
          catch( e ) {}

          if (
            parsed &&
            parsed.year !== undefined &&
            parsed.month !== undefined &&
            parsed.day !== undefined &&
            parsed.hours !== undefined &&
            parsed.minutes !== undefined
          ) {
            if ( parsed.seconds === undefined ) parsed.seconds = 0;
            v = dates.format( parsed, dates.types.STRUCT, dates.types.RUS4Y, true, true )
          }
          else v = null;

          if ( event == "blur" ) {
            if ( this.dateData_ && !v ) v = this.dateData;
          }
          else if ( event == "ok" ) {
            if ( this.dateData_ && !v ) {
              this.dateDataErr = this.$t( "DateInvalid" );
              return;
            }
          }
        }

        this.dateData = v;
        this.dateData_ = v;
      }
    },

    computed: {
      userName() {
        return this.$store.state.user.name;
      }
    },

    watch: {
		  dateData: {
		    immediate: true,
        handler( nv ) {
  		    this.dateData_ = nv;
        }
      }
    }
	};
</script>

<style>
	@import './assets/styles/index.css';

  #header {
    padding: 1em 1em 1em 3em;
    background-color: #0081CA;
    color: #FFFFFF;
    font-weight: bold;
    height: auto;
    min-height:2em;
    font-family: Ubuntu, Verdana;
    background-image: url(assets/imgs/logo.svg);
/*
    background-size: auto 1.5em;
    background-repeat: no-repeat;
    background-position: 0.1em 0.2em;
*/

    background-size: auto 1.8em;
    background-repeat: no-repeat;
    background-position: 0.5em 0.7em;
  }

  #header > .title {
    text-decoration: none;
    color: #FFFFFF;
    position: relative;
  }
  #header > .title::after {
    content: "";
    position: absolute;
    top: -0.5em;
    left: -2.5em;
    right: 0;
    height: 2em;
  }

  #header > .user {
    float: right;
    font-weight: normal;
    color: #FFFFFF;
    position: relative;
    font-size: 0.9em;
    margin-top: -0.15em;
  }

  #header > .user > .logoutIcon {
    height: 1.4em;
    width: auto;
    margin-right: 0.5em;
  }

  #header > .langInterf,
  #header > .langData,
  #header > .dateData {
    display: inline-block;
    color: #000000;
    background-color: #FFFFFF;
    font: inherit;
    box-sizing: border-box;
    font-weight: normal;
    border-radius: 0.2em;
    padding: 0.1em 0.2em;
    position: relative;
    margin-left: 2em;
  }
  #header > .langInterf::before,
  #header > .langData::before,
  #header > .dateData::before {
    content: attr( data-content );
    position: absolute;
    top: -1.6em;
    left: 0;
    color: #FFFFFF;
    font-size: 0.8em;
  }

  #header > .langInterf > select,
  #header > .langData > select {
    min-height: 1em;
    padding: 0;
    border-radius: 0.2em;
    box-sizing: border-box;
    font: inherit;
    border: none;
    line-height: 1.2em;
    width: 100%;
    height: 1.2em;
    background-color: transparent;
  }
  #header > .langInterf::after,
  #header > .langData::after {
    content: "";
    position: absolute;
    width: 1em;
    height: 1.5em;
    right: 0.1em;
    top: 0;
    background-color: #FFFFFF;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2016%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%3Cpath%20d%3D%22m0%200%208%208%208-8z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-size: 0.8em auto;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    pointer-events: none;
  }

  #header > .dateData {
    padding: 0;
    width: 14em;
    font: inherit;
    font-weight: normal;
  }
  #header > .dateData .dateDataInput {
    box-shadow: none;
    font: inherit;
    padding: 0.1em 3em 0.1em 0.2em;
    width: 100%;
  }
  #header > .dateData.choiced > * {
    background-color: #FF2929;
    color: #FFFFFF;
  }
  #header > .dateData > .clear {
    position: absolute;
    top: 50%;
    transform: translate( 0, -50% );
    right: 1.7em;
    width: 0.8em;
    cursor: pointer;
  }
  #header > .dateData > .clear:active {
    margin: 1px -1px 0 0;
  }

  #header > .prefs {
    float: right;
    font-weight: normal;
    color: #FFFFFF;
    position: relative;
    font-size: 0.9em;
    margin: -0.15em 1em 0 0;
  }
</style>
